// extracted by mini-css-extract-plugin
export default {"overlay":"NotificationLetter_overlay__cs6fI","centeredImage":"NotificationLetter_centeredImage__lxSJz"};